import { render } from "./bannerSeting.vue?vue&type=template&id=f891227e&scoped=true"
import script from "./bannerSeting.vue?vue&type=script&lang=js"
export * from "./bannerSeting.vue?vue&type=script&lang=js"

import "./bannerSeting.vue?vue&type=style&index=0&id=f891227e&lang=scss"
import "./bannerSeting.vue?vue&type=style&index=1&id=f891227e&scoped=true&lang=scss"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f891227e"]])

export default __exports__